import React from "react";
import { HiOutlineInformationCircle } from "react-icons/hi";

interface ReInviteModalProps {
  show: boolean;
  onClose: () => void;
  name?: string;
  email?: string;
  onConfirm: () => void;
  loading?: boolean;
}

const ReInviteModal: React.FC<ReInviteModalProps> = ({ show, onClose, name, email, onConfirm, loading }) => {
  if (!show) return null;

  return (
    <div style={{ zIndex: 99999 }} className="fixed inset-0 flex items-center justify-center p-4">
      <div className="absolute inset-0 bg-black/50 dark:bg-black/70 backdrop-blur-sm" onClick={onClose} />

      <div className="relative bg-white dark:bg-gray-800 rounded-xl shadow-2xl border border-gray-200 dark:border-gray-700 p-6 mx-4 max-w-md w-full transform transition-all">
        <div className="flex items-center justify-center w-12 h-12 mx-auto mb-4 bg-blue-100 dark:bg-blue-900/30 rounded-full">
          <HiOutlineInformationCircle className="w-6 h-6 text-blue-600 dark:text-blue-400" />
        </div>

        <p className="text-sm text-gray-900 dark:text-gray-100 text-center mb-4">
          <span className="font-medium text-base">Re-invite</span>
          {name || email ? (
            <>
              <span className="block mt-1">
                <span className="font-semibold">{name}</span>
                {email && (
                  <span className="ml-1 px-2 py-0.5 rounded-md bg-gray-100 dark:bg-gray-700 text-gray-700 dark:text-gray-200 font-mono text-xs align-middle">
                    {email}
                  </span>
                )}
                <span className="font-medium ml-1">?</span>
              </span>
            </>
          ) : (
            " this person?"
          )}
        </p>

        <p className="text-sm text-gray-600 dark:text-gray-300 text-center mb-4">
          User currently has no login access. Re-invitation will send them an invite link that must be accepted to restore access and enable task suggestions.
        </p>

        <div className="flex justify-center gap-2">
          <button
            onClick={onClose}
            disabled={!!loading}
            className="px-4 py-2 text-sm font-medium text-gray-700 dark:text-gray-200 bg-gray-100 dark:bg-gray-700 hover:bg-gray-200 dark:hover:bg-gray-600 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-gray-300 dark:focus:ring-gray-600"
          >
            Cancel
          </button>
          <button
            onClick={onConfirm}
            disabled={!!loading}
            className="px-4 py-2 text-sm font-medium text-white bg-blue-600 hover:bg-blue-700 rounded-lg transition-colors focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-blue-500 dark:focus:ring-blue-400 disabled:opacity-60 disabled:cursor-not-allowed"
          >
            {loading ? 'Inviting…' : 'Re-invite user'}
          </button>
        </div>
      </div>
    </div>
  );
};

export default ReInviteModal;


